import UrlInput from 'shared/components/inputs/url-input'
import css from './url-input.css'

const Input = ({ fileTypes, onError, onFileAccepted, urlAccepted, needsCORS, checkLoginStatus, isLoggedIn }) => (
    <UrlInput
        placeholder={`Paste any media or GIF URL`}
        fileTypes={fileTypes}
        onError={onError}
        onFileAccepted={onFileAccepted}
        disabled={urlAccepted}
        needsCORS={needsCORS}
        checkLoginStatus={checkLoginStatus}
        isLoggedIn={isLoggedIn}
        className={urlAccepted ? css.inputFieldAccepted : css.inputField}
    />
)

const Check = () => (
    <div className={css.icons}>
        <div className={css.check} />
    </div>
)

const UrlInputWrapper = ({ fileTypes, onError, onFileAccepted, urlAccepted = false, checkLoginStatus, isLoggedIn }) => (
    <div className={css.container}>
        <div className={css.title}>Add Any URL</div>
        <div className={css.description}>We support YouTube, Vimeo, and GIPHY links!</div>
        <div className={css.ctaWrapper}>
            <div className={css.inputFieldContainer}>
                <Input {...{ fileTypes, onError, onFileAccepted, urlAccepted, checkLoginStatus, isLoggedIn }} />
                {urlAccepted ? (
                    <Check />
                ) : (
                    <div className={css.icons}>
                        <div className={css.giphy} />
                        <div className={css.youtube} />
                        <div className={css.vimeo} />
                    </div>
                )}
            </div>
        </div>
    </div>
)

export const UrlInputWrapperUpload = ({
    fileTypes,
    onError,
    onFileAccepted,
    urlAccepted = false,
    checkLoginStatus,
    isLoggedIn,
    children,
}) => (
    <div className={css.container}>
        <div className={css.title}>Any URL</div>
        <div className={css.secondary}>We support YouTube, Vimeo, and many others!</div>
        <div className={css.ctaWrapper}>
            <div className={css.inputFieldContainer}>
                <Input
                    {...{
                        fileTypes,
                        onError,
                        onFileAccepted,
                        urlAccepted,
                        needsCORS: false,
                        checkLoginStatus,
                        isLoggedIn,
                    }}
                />
                {urlAccepted && <Check />}
            </div>
            {/* This can be explicitly named if we need to configure this more */}
            {children}
        </div>
    </div>
)

export default UrlInputWrapper
